import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export const formatStringToDate = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  date?: string
) => {
  if (event?.target?.value) {
    const timeSplitted = event.target.value.split(":");

    if (timeSplitted && timeSplitted?.length > 0) {
      const oldDate = date ? new Date(date) : new Date();

      oldDate.setHours(Number(timeSplitted[0]), Number(timeSplitted[1]));

      const dateFormatted = zonedTimeToUtc(
        oldDate,
        Intl.DateTimeFormat().resolvedOptions().timeZone
      ).toISOString();

      return dateFormatted;
    }
  }

  return "";
};

export const formatTimeByString = (date: string) => {
  try {
    if (date) {
      return format(
        utcToZonedTime(date, Intl.DateTimeFormat().resolvedOptions().timeZone),
        "HH:mm"
      );
    }

    return "";
  } catch (err) {
    return "";
  }
};
